import React from "react";
import { createGlobalStyle } from "styled-components";

import global from './styles';
import antdStyles from './antd';
import containerStyles from './container';

export default createGlobalStyle`
  ${global}
  ${antdStyles}
  ${containerStyles}
`;